import enMessages from "./en.json";
import esMessages from "./es.json";
import enNotifications from "./notifications.en.json";
import esNotifications from "./notifications.es.json";
import enChangelog from "./changelog.en.json";
import esChangelog from "./changelog.es.json";

import dynamicEnMessages from "./dynamic_en.json";
import dynamicEsMessages from "./dynamic_es.json";

require("dayjs/locale/es");

import enUS from "antd/locale/en_US";
import esES from "antd/locale/es_ES";

const messages = {
  en: {
    messages: {
      ...enMessages,
      ...enNotifications,
      ...dynamicEnMessages,
      ...enChangelog,
    },
    ant: enUS,
  },
  es: {
    messages: {
      ...esMessages,
      ...esNotifications,
      ...dynamicEsMessages,
      ...esChangelog,
    },
    ant: esES,
  },
};

export type AvailableLocales = keyof typeof messages;

const Config = (locale: keyof typeof messages) => {
  return {
    locale,
    ...messages[locale],
  };
};

export default Config;
